import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { SessionTimerService } from '../services/session-timer.service';
import { StudentDataService } from '../services/student-data.service';

const SESSION_PRESETS_MINUTES = [1, 2, 5];
const STORAGE_KEY = 'wf_dev_tools_visible';

@Component({
  selector: 'dev-tools',
  templateUrl: './dev-tools.component.html',
  standalone: true,
})
export class DevToolsComponent implements OnInit, OnDestroy {
  private sessionTimerService = inject(SessionTimerService);
  private studentDataService = inject(StudentDataService);

  readonly sessionPresets = SESSION_PRESETS_MINUTES;
  timeLeft: string | null = null;
  visible = localStorage.getItem(STORAGE_KEY) !== 'false';

  private interval: any = null;

  ngOnInit() {
    this.interval = setInterval(() => {
      const expiration = this.studentDataService.getSessionExpirationTime();
      if (expiration != null) {
        const remaining = Math.max(0, expiration - Date.now());
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        this.timeLeft = `${minutes}:${seconds.toString().padStart(2, '0')}`;
      } else {
        this.timeLeft = null;
      }
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  toggle() {
    this.visible = !this.visible;
    localStorage.setItem(STORAGE_KEY, String(this.visible));
  }

  setSessionMinutes(minutes: number) {
    this.sessionTimerService.startTimers(minutes);
  }
}
